<template>
  <div class="columns">
    <div class="col-2">
      <div class="LandingPageHeaderText">
        <p>Stake.</p>
        <p>Create.</p>
        <p>Develop.</p>
      </div>
      <div class="LandingPageSubHeaderText">
        <p>
          Join us to earn rewards on your staked SCRT and help secure the Secret
          Network.
        </p>
      </div>
      <div class="LandingPageButtonDiv">
        <!--<button
          class="button StakeButton"
          onclick="window.open('https://puzzle.report/secret/chains/secret-2/validators/45521282C12E0EC1691495FCA714947DCA072745','_blank')"
          type="button"
        >-->
        <button
          class="button StakeButton"
          @click="stakingModalShow"
          type="button"
        >
          <span>Stake With Us</span>
        </button>
      </div>
    </div>
    <div class="col-2 youtube">
      <iframe
        width="500"
        height="280"
        src="https://www.youtube.com/embed/fkgy83Hu8Bc"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div class="announcement">
      Interested in Staking? Check out our
      <a href="/stakingcalculator">Staking ROI Calculator!</a>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    stakingModalShow() {
      this.$modal.show("myStakingPopup");
      this.$emit("child-click");
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.columns {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 95%;
  margin: 2rem auto;
}

.col-2 {
  width: 48%;
  min-width: 500px;
}

.LandingPageHeaderText {
  font-size: 500%;
  font-weight: 600;
  color: #141a3c;
  padding-left: 10%;
  text-align: left;
  margin-top: 10px;
  line-height: 120%;
}

.LandingPageSubHeaderText {
  font-size: 150%;
  color: #090a0b;
  padding-top: 10px;
  padding-left: 10%;
  text-align: left;
  padding-right: 10%;
}

.LandingPageButtonDiv {
  padding-left: 13%;
  padding-top: 1.5em;
  display: flex;
  justify-content: left;
  text-align: left;
}

.button {
  border: none;
  color: white;
  padding: 15px 32px;
  text-decoration: none;
  font-size: 24px;
  margin: 0;
  cursor: pointer;
}

.StakeButton {
  background-color: rgb(20, 26, 60);
  border-radius: 5px;
  color: white;
}

.StakeButton span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.StakeButton span:after {
  content: "\00bb";
  position: relative;
  opacity: 0;
  top: 0;
  right: 0px;
  transition: 0.5s;
}

.StakeButton:hover span {
  padding-right: 15px;
}

.StakeButton:hover span:after {
  opacity: 1;
  right: 1;
}

.button:hover {
  background-color: #555;
}

iframe {
  padding-top: 30px;
}
.youtube {
  text-align: center;
}

.announcement {
  text-align: center;
  /*font-size: 30px;*/
  font-size: 25px;
  margin: 0 auto;
  margin-top: 60px;
  width: 85%;
}

.announcement a {
  color: #455283;
  font-weight: 900;
  text-decoration: underline;
}

@media (max-width: 900px) {
  iframe {
    width: 400px;
    height: 225px;
  }
  .announcement {
    width: 90%;
  }
}
@media (max-width: 500px) {
  iframe {
    width: 300px;
    height: 168px;
  }
}

@media (max-width: 500px) {
  .col-2 {
    width: 100%;
    min-width: 300px;
  }
}

@media (max-width: 360px) {
  .LandingPageHeaderText {
    padding-left: 3px;
  }
  .LandingPageSubHeaderText {
    padding-left: 3px;
  }
}
</style>
